var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"pa-10  rounded-lg d-flex justify-center align-center border",style:(_vm.cssVars),attrs:{"height":"80","width":"720px","flat":""}},[_vm._l((_vm.items),function(item){return [_c('v-avatar',{key:item.id,class:[
                    _vm.selectedStep === item.id ? 'selected' : 'unselected',
                    _vm.selectedStep > item.id ? 'stepcomplete' : '',
                    _vm.selectedStep < item.id ? 'border' : 'unborder'
                ],style:(_vm.cssVars)},[_c('v-icon',{class:[
                        item.icon,
                        _vm.selectedStep === item.id
                            ? 'selectedIcon'
                            : 'unselectedIcon'
                    ],style:(_vm.cssVars)},[_vm._v(_vm._s(item.icon))])],1),_c('h5',{key:item.label,staticClass:"ml-2 mt-3 mr-4 textStep",style:(_vm.cssVars)},[_vm._v(" "+_vm._s(item.label)+" ")])]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }